// Feature flags for feature toggles
export const FEATURE_FLAGS = {
  DEMO_MODE: true,
};
